
export const TrainingPlan = {
    path: '/training_plans',
    name: 'training_plans',
    component: () => import('@/views/Training/TrainingPlan/TrainingPlanPage.vue'),
    children: [
        {
            path: '/training_plans/add',
            name: 'training_plans.add',
            component: () => import('@/views/Training/TrainingPlan/Form/TrainingPlanForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/training_plans/edit/:id',
            name: 'training_plans.edit',
            component: () => import('@/views/Training/TrainingPlan/Form/TrainingPlanForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/training_plans/lock/:id',
            name: 'training_plans.lock',
            component: () => import('@/views/Training/TrainingPlan/Form/TrainingPlanForm.vue'),
            props: {lockAction: true}
        },
        {
            path: '/training_plans/delete/:id',
            name: 'training_plans.delete',
            component: () => import('@/views/Training/TrainingPlan/Form/TrainingPlanForm.vue'),
            props: {deleteAction: true}
        },
    ],
}